module.exports = __webpack_public_path__ + "img/field-manager-logo.0fd1a8d1.svg";